import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "../configs/AppConfig";

const DiagnosisService = {};

DiagnosisService.addDiagnosis = function (data) {
  return fetch({
    url: API_BASE_URL + "/v1/admin/add-diagnosis",
    method: "post",
    data: data,
  });
};

DiagnosisService.getAllDiagnosis = function (params) {
  let page = params;
  let offset = (page - 1) * 10;
  return fetch({
    url: API_BASE_URL + "/v1/admin/get-all-diagnosis",
    method: "get",
    //data: data,
    params: {
      offset: offset,
    },
  });
};

DiagnosisService.updateDiagnosis = function (data) {
  return fetch({
    url: API_BASE_URL + "/v1/admin/update-diagnosis",
    method: "post",
    data: data,
  });
};

export default DiagnosisService;
